export default __webpack_public_path__ + "static/media/O-148.017731d9.png";